import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';


import '../css/OkasBoxesView.css';  // Same Css for OkasBoxesView and SubscriptionView
import ErrorText from '../ErrorText';


//Subscription view page

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    // minHeight: '10%',
    // maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: 'white',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const SUbType = [  
// { label: 'Master Controller' },
// { label: 'VOD Box' },
// { label: 'UVOD Box' },
// { label: 'Audio Box' },
// { label: 'Home Theatre Box' },
];


export default class SubscriptionView extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
    SUbType: this.props.SUbCurrentData.okasBox_type,
    // ObSerialNo: this.props.ObCurrentData.okasBox_serialNo,
    // ObRegistrationId: this.props.SUbCurrentData.okasBox_serialNo,
    projectName: this.props.SUbCurrentData.project_name,
    mobileNumber: this.props.SUbCurrentData.mobile_number,
    ownerName: this.props.SUbCurrentData.owner_name,
    subscriptionPlan: this.props.SUbCurrentData.subscription_status,
    billingAddress: this.props.SUbCurrentData.Address,
    dateOfExpiry: this.props.SUbCurrentData.subscription_end_date,
    email: this.props.SUbCurrentData.client_email,
    paymentMobile: this.props.SUbCurrentData.payment_status,
    // ObLicenseId: this.props.SUbCurrentData.okasBox_version,
    errorMessage: [],
    modalIsOpenSuccess: false,
    showErrorMessage: false,
    SUbAvailable: true,
    publicVersion: []


  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.closeModalSuccess = this.closeModalSuccess.bind(this);

}

openModal() {
  this.setState({modalIsOpen: true});
}    
closeModalSuccess() {
  this.setState({
    modalIsOpenSuccess: false
  });
}

closeModalSuccess() {
  this.setState({
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpenSuccess: false
      })
    }, 500);

  })
}
afterOpenModal() {
  // references are now sync'd and can be accessed.
  // this.subtitle.style.color = '#f00';
}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.props.refreshDevices();
      this.setState({
        modalIsOpen: false
      })
    }, 500);

  })
}

onSelectChange = (operationMode, valueSelect) => {
  if (operationMode === 'subType') {
    this.setState({
      SUbType: valueSelect.value,
      errorMessage: []
    })
  } else if (operationMode === 'subVersion') {
    this.setState({
      ObLicenseId: valueSelect.value,
      errorMessage: []
    })
  }
}

componentDidMount(){
  // console.log('worked from dhuihdas')
    this.fecthAllSI();
    this.fetchPublicVersion()

}

fecthAllSI = ()=>{
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/subscriptionApi/' ,{
          method: "GET",
          headers: headers,
      })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  this.setState({
    subData: data
  },()=>console.log(this.state))
  console.log('subData:',data)  
})

.catch((err)=>{
  console.log(err)

})
}


// AddingSUB = () => {
//   let okasBox_type = this.state.SUbType;
//   // let okasBox_serialNo = this.state.ObSerialNo;
//   let okasBox_serialNo = this.state.ObRegistrationId;
//   let okasBox_version = this.state.ObLicenseId;
//   console.log(this.state)
  
//   var tokenStored = localStorage.getItem('token');
//     tokenStored = `Token ${tokenStored}`
//     var headers = {
//       'Content-Type': 'application/json',
//       "Access-Control-Allow-Origin": "*",
//       'X-CSRFToken': localStorage.getItem('csrftoken'),
//       'Authorization': tokenStored
//   }

//     fetch(`/cloud/okasBoxApi_Detail/${this.props.SUbCurrentData.okasBox_id}` ,{
//             method: "PUT",
//             headers: headers,
//             body: JSON.stringify({
//               okasBox_type,              
//               okasBox_serialNo,
//               okasBox_version,
//                   })
//         })
//            .then(response => {
//               if(response.status===403){
//                 localStorage.removeItem('token');
//                 localStorage.removeItem('csrftoken');
//                 localStorage.removeItem('auth');
//                 const history = createHistory({forceRefresh: true})
//                 history.push('/session-timeout')
//               }else{
//                   return response.json()}
//               })
//   .then(data => {
//     let index = Object.keys(data)[0]
//     console.log(index + ": " + data[Object.keys(data)[0]])
//     if(data.message!=="failure"){
//       this.setState({
//         modalIsOpen:false,
//         modalIsOpenSuccess:true,
//         subData: data
//       })
//     }
//   })
//   .catch((err)=>{
//     console.log(err)

//   })
//   ;
// }


// AddSUB = () => {
//   this.setState({
//     showErrorMessage: true
//   },()=>{
//     this.fetchError((e)=>{
//      if(e==='NoError'){
//        this.AddingSUB();
//      }
//     })
//   })
// }

checkSUBSerialNo = (e) =>{
  let data = '';
  this.state.subData.forEach((e)=>{
    if(e.si_userName===this.state.ObRegistrationId){
    data = 'username exist';
    }
  })
  if(data==='username exist'){
    this.setState({
      SUBAvailable:false
    })
  }
}
// fetchError = (noError) => {
//   var totalError = 3;
//   if(ErrorText('notEmpty', this.state.SUbType)==='No Error'){
//     totalError=totalError-1;
//   }
 
//   if(ErrorText('notEmpty', this.state.ObRegistrationId)==='No Error'){
//     totalError=totalError-1;
//   }

//   if(ErrorText('notEmpty', this.state.ObLicenseId)==='No Error'){
//     totalError=totalError-1;
//   }

// if(totalError===0){
//   noError('NoError');
// }
// }



handleChangeInputBox = (name, event) => {
  this.setState({
    [name]: event
  },()=>{
    if(name==='SUbSerialNo'){
      this.checkSUBSerialNo()
    }

  });
};

fetchPublicVersion = () => {
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
  }
  fetch('/cloud/subscriptionApi/', {
    method: "GET",
    headers: headers,
  })
             .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
    .then(data => {
      if (data.detail === 'Invalid token.') {
        console.log('Invalid token. Please log in again.');
        // localStorage.clear();
      } else {
        // console.log(data)
        let publicVersion = [];
        data.forEach((sumValue) => {
          publicVersion.push({ label: sumValue.id })
        })
        this.setState({ publicVersion })
      }
      console.log('sbData:',data)  //check
    })
    .catch((err)=>{
      console.log(err)
    })
}
  

  
    render(){
      const dateFromString = new Date(this.state.dateOfExpiry);
      const dateOnly = dateFromString.toISOString().split('T')[0];
        return (
          <React.Fragment>
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen} 
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}} >SUBSCRIPTION DETAILS</h3>
          <div className="row" style={{margin: '0px'}}>
         
             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.projectName}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="PROJECT NAME:"
               inputBoxName="project_name"
              //  handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 
               

               />
             </div>  

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.mobileNumber}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="MOBILE NUMBER:"
               inputBoxName="mobileNumber"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.ownerName}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="OWNER NAME:"
               inputBoxName="ownerName"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
              //  inputText={(this.state.subscriptionPlan).toUpperCase()}
              inputText={(this.state.subscriptionPlan || "").toUpperCase()}

              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="SUBSCRIPTION PLAN:"
               inputBoxName="subscriptionPlan"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div>  

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.billingAddress}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="BILLING ADDRESS:"
               inputBoxName="billingAddress"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div>  

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={dateOnly}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="DATE OF EXPIRY:"
               inputBoxName="dateOfExpiry"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div>   

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={this.state.email}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="EMAIL:"
               inputBoxName="email"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 

               />
             </div> 

             <div className="col-6 pl-0 disableEvent" style={{padding: '0px', margin: '0px',marginLeft: '-9px'}}>
             <InputBox 
               inputText={(this.state.paymentMobile).toUpperCase()}
              //  error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage  ? true : false}
              //  errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId)!=='No Error' && this.state.showErrorMessage ? 'Registration ID cannot be left blank  and have min 6 in length.' : ''}
               placeholder="PAYMENT STATUS:"
               inputBoxName="paymentMobile"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={16}
                validate={true}
                disableEvent={true} 
              

               />
             </div>      
          
            </div>
            <div className="float-right" style={{marginTop: '70px', marginRight: '-15px' }}>
               <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>              
             </div>
             {/* <div className="float-right" style={{marginTop: '70px', marginBottom: '70px'}}> */}
             {/* <div className="btn btn-new-grey" onClick={this.closeModal}>Close</div>   */}
               {/* <div className="btn modal-submit-btn mx-4 px-5" onClick={this.AddOB.bind(this)}>Save Changes</div>               */}
             {/* </div> */}
        </Modal>
        {/* <Modal
                 isOpen={this.state.modalIsOpenSuccess}
                 style={customStylesSuccess}
                 className={this.state.modalStateAftereOpenSuccess}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">OKAS Box edited successfully.</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <div className="btn reset-btn mx-2 px-5"
                  onClick={(e)=>{
                            const history = createHistory({forceRefresh: true})
                            history.push('/okasboxes/dashboard')}}>
                              Close 
                            </div>
            </div>
            </Modal>  */}
          </React.Fragment>
        );
    }
}
